export const publicBrandText = (value) => {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/\bALYF\s+by\s+Elivaas\b/gi, 'Homevilas')
    .replace(/\bElivaas\b/gi, 'Homevilas')
    .replace(/\belivaas\b/g, 'homevilas')
    .replace(/\bELIVAAS\b/g, 'HOMEVILAS');
};
